import React, { useEffect, useState } from 'react'
import { cn } from '@utils/safeTs'
import { LogStatoPosizionePersonalizzazioneOrdineType } from '@utils/types'
import useTrans from '@hooks/useTrans'
import Button from '../Button/Button'
import styles from './FlussoPersonalizzazioneNotaValue.module.sass'


interface Props {
  value?: string
  log?: LogStatoPosizionePersonalizzazioneOrdineType
  header?: React.ReactNode
  placeholder?: string
  variant?: 'default' | 'accent' | 'warning'
  className?: string
}

const FlussoPersonalizzazioneNotaValue = (props: Props) => {

  const { 
    value,
    log,
    header,
    placeholder,
    variant = 'default',
    className = '',
  } = props

  const t = useTrans()
  const [mostraOriginale, setMostraOriginale] = useState(false)
  useEffect(() => setMostraOriginale(false), [log?.id, log?.note, log?.noteTradotta])
  const testo = log ? (mostraOriginale ? log.note : log.noteTradotta || log.note) : value
  // Il backend restituisce l'originale anche in noteTradotta quando manca una traduzione.
  const toggle = !!log?.noteTradotta && log.noteTradotta !== log.note && (
    <div className={styles.translationControls}>
      {!mostraOriginale && (
        <span className={styles.translationNotice}>
          {t('Traduzione automatica generata da IA')}
          {' — '}
        </span>
      )}
      <Button
        label={t(mostraOriginale ? 'Mostra traduzione' : 'Vedi originale')}
        size="small"
        className={styles.toggle}
        onClick={() => setMostraOriginale(value => !value)}
      />
    </div>
  )

  return (
    <>
      {header}
      <div className={cn(styles.root, testo ? '' : styles['root--empty'], styles[`root--${variant}`], className)}>
        <span className={styles.value}>{testo || placeholder}</span>
      </div>
      {toggle}
    </>
  )
}

export default FlussoPersonalizzazioneNotaValue
